import { render, staticRenderFns } from "./EditForm.vue?vue&type=template&id=44fd3a84&"
import script from "./EditForm.vue?vue&type=script&lang=js&"
export * from "./EditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44fd3a84')) {
      api.createRecord('44fd3a84', component.options)
    } else {
      api.reload('44fd3a84', component.options)
    }
    module.hot.accept("./EditForm.vue?vue&type=template&id=44fd3a84&", function () {
      api.rerender('44fd3a84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/pages/HotelPlanner/Components/EditForm.vue"
export default component.exports